module.exports = __webpack_public_path__ + "static/media/bn_freeAPI_210622_02.354ec54d.png";